<template>
  <div class="w-full mb-6">
    <!-- Dokumen Surat -->
    <div class="w-full mb-5" v-if="documentsSigned.length == 0">
      <h6 class="mb-3">Surat</h6>
      <global-wrapper
        :loading="fileLoading"
        :empty="documents.length <= 0"
        loadingType="twoLine"
      >
        <global-file-upload
          v-for="(item, index) in documents"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              color="primary"
              icon="icon-edit-2"
              icon-pack="feather"
              size="small"
              class="mr-2"
              v-if="
                surat.isUserCanSign({
                  userId: $user.uuid,
                  documentAttribute: item.attribute
                }) && surat.isUserOnDisposition($user.id)
              "
              @click="$refs.dialogSignature.toggleActive(true, item)"
              >Tanda Tangan</vs-button
            >
            <vs-button
              color="primary"
              type="border"
              icon="icon-edit"
              icon-pack="feather"
              size="small"
              class="mr-2"
              v-if="
                surat.isUserOnDisposition($user.id) &&
                  surat.isUserCanEdit($user.id) && 
                  surat.tipe == 'surat_keluar'
              "
              @click="handleSettingSurat(item.uuid)"
              >Setting</vs-button
            >

            <vs-button
              color="primary"
              type="border"
              icon="icon-eye"
              icon-pack="feather"
              size="small"
              class="mr-2"
              @click="handleShowSurat(item.uuid)"
              v-if="surat.tipe == 'surat_keluar'"
              >Lihat</vs-button
            >

            <vs-button
              color="primary"
              type="border"
              icon="icon-download"
              icon-pack="feather"
              size="small"
              @click="downloadFile(item.file_url)"
              >Download</vs-button
            >

            <vs-button
              color="danger"
              type="border"
              icon="icon-trash"
              icon-pack="feather"
              size="small"
              v-if="
                surat.isUserOnDisposition($user.id) &&
                  surat.isUserCanEdit($user.id)
              "
              @click="removeDocument(item.uuid, 'surat')"
              >Hapus</vs-button
            >
          </template>
        </global-file-upload>
        <template #empty>
          <div class="w-full mb-2">Belum ada surat yang di upload</div>
          <input
            type="file"
            class="hidden"
            ref="uploadSurat"
            v-on:change="onChangeFileUpload($event, 'surat')"
            name="upload-surat"
            accept=".jpg,.jpeg,.png,.docx,.xlsx,.pdf"
          />
          <vs-button
            type="border"
            size="small"
            icon-pack="feather"
            icon="icon-upload"
            @click="uploadFile('surat')"
            >Upload Surat</vs-button
          >
        </template>
      </global-wrapper>
    </div>
    <div class="w-full mb-5" v-else>
      <h6 class="mb-3">Surat yang telah Di TTE</h6>
      <global-wrapper
        :loading="fileLoading"
        :empty="documentsSigned <= 0"
        loadingType="twoLine"
      >
        <global-file-upload
          v-for="(item, index) in documentsSigned"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              color="primary"
              type="border"
              icon="icon-download"
              icon-pack="feather"
              size="small"
              @click="downloadFile(item.file_url)"
              >Download</vs-button
            >

            <vs-button
              color="danger"
              type="border"
              icon="icon-trash"
              icon-pack="feather"
              size="small"
              v-if="surat.isUserOnDisposition($user.id)"
              @click="removeDocument(item.uuid, 'surat')"
              >Hapus</vs-button
            >
          </template>
        </global-file-upload>
      </global-wrapper>
    </div>

    <!-- Dokumen Lampiran Surat -->
    <div class="w-full" v-if="lampiransSigned.length != 0">
      <h6 class="mb-3">Lampiran yang sudah di TTE</h6>
      <global-wrapper :loading="fileLoading" :empty="lampiransSigned.length <= 0" loadingType="twoLine">
        <global-file-upload
          v-for="(item, index) in lampiransSigned"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              color="primary"
              type="border"
              icon="icon-download"
              icon-pack="feather"
              size="small"
              @click="downloadFile(item.file_url)"
              >Download</vs-button
            >
            <vs-button
              color="danger"
              type="border"
              icon="icon-trash"
              icon-pack="feather"
              size="small"
              v-if="surat.isUserOnDisposition($user.id)"
              @click="removeDocument(item.uuid, 'lampiran')"
              >Hapus</vs-button
            >
          </template>
        </global-file-upload> 
        <template #empty>
          <div class="w-full mb-2">Belum ada lampiran yang di upload</div>
        </template>
      </global-wrapper><br>
    </div>
    <div class="w-full">
      <h6 class="mb-3">Lampiran</h6>
      <global-wrapper :loading="fileLoading" :empty="lampirans.length <= 0" loadingType="twoLine">
        <global-file-upload
          v-for="(item, index) in lampirans"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              color="primary"
              icon="icon-edit-2"
              icon-pack="feather"
              size="small"
              class="mr-2"
              v-if="
                surat.isUserCanSign({
                  userId: $user.uuid,
                  documentAttribute: item.attribute
                }) && surat.isUserOnDisposition($user.id)
              "
              @click="$refs.dialogSignature.toggleActive(true, item)"
              >Tanda Tangan</vs-button
            >
            <vs-button
              color="primary"
              type="border"
              icon="icon-edit"
              icon-pack="feather"
              size="small"
              class="mr-2"
              v-if="
                surat.isUserOnDisposition($user.id) &&
                  surat.isUserCanEdit($user.id) &&
                  surat.tipe == 'surat_keluar'
              "
              @click="handleSettingSurat(item.uuid)"
              >Setting</vs-button
            >

            <vs-button
              color="primary"
              type="border"
              icon="icon-eye"
              icon-pack="feather"
              size="small"
              class="mr-2"
              @click="handleShowSurat(item.uuid)"
              v-if="surat.tipe == 'surat_keluar'"
              >Lihat</vs-button
            >

            <vs-button
              color="primary"
              type="border"
              icon="icon-download"
              icon-pack="feather"
              size="small"
              @click="downloadFile(item.file_url)"
              >Download</vs-button
            >

            <vs-button
              color="danger"
              type="border"
              icon="icon-trash"
              icon-pack="feather"
              size="small"
              v-if="
                surat.isUserOnDisposition($user.id) &&
                  surat.isUserCanEdit($user.id)
              "
              @click="removeDocument(item.uuid, 'lampiran')"
              >Hapus</vs-button
            >
          </template>
        </global-file-upload> 

        <template #empty>
          <div class="w-full mb-2">Belum ada lampiran yang di upload</div>
        </template>
      </global-wrapper><br>

      <input
        type="file"
        accept=".jpg,.jpeg,.png,.docx,.xlsx,.pdf"
        class="hidden"
        ref="uploadLampiran"
        v-on:change="onChangeFileUpload($event, 'lampiran')"
        name="upload-lampiran"
      />
      
      <vs-button
        @click="uploadFile('lampiran')"
        type="border"
        size="small"
        icon-pack="feather"
        icon="icon-upload"
        v-if="surat.isUserOnDisposition($user.id) && surat.isUserCanEdit($user.id)"
      >
        Tambah Lampiran
      </vs-button>
    </div>

    <DialogSignature ref="dialogSignature" @submitCallback="submitCallback"/>
    <LoadingDialog 
      ref="loadingDialog" 
      :progress="progress"
      @onAccept="submitCallback" 
      @onCancel="removeDocument(responseValue.uuid, 'yang batal di upload')"
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { digofHttp as axios } from "@/axios";

import DialogDokumen from "./DialogDokumen";
import DialogSignature from "./DialogSignature";
import LoadingDialog from "@/components/dialog/LoadingDialog";

export default {
  components: {
    DialogDokumen,
    DialogSignature,
    LoadingDialog
  },
  props: {
    surat: {
      type: Object
    }
  },
  data() {
    return {
      fileLoading: false,
      progress: 0,
      responseValue: []
    };
  },
  computed: {
    documents() {
      return this.surat.dokumen.filter(data => {
        return data.tipe == "surat_keluar" || data.tipe == "surat_masuk";
      });
    },
    lampirans() {
      return this.surat.dokumen.filter(data => {
        return data.tipe == "lampiran";
      });
    },
    documentsSigned() {
      let documents = this.surat.dokumen.filter(data => {
        return data.tipe == "surat_keluar_signed" || data.tipe == "surat_keluar_signed_alter";
      });

      documents.sort(function(a, b) {
        return b.id - a.id;
      });

      return documents;
    },
    lampiransSigned() {
      let lampirans = this.surat.dokumen.filter(data => {
        return data.tipe == "lampiran_signed" || data.tipe == "lampiran_signed_alter";
      });

      lampirans.sort(function(a, b) {
        return b.id - a.id;
      });

      return lampirans;
    }
  },
  methods: {
    ...mapActions({
      toggleSettingSurat: "surat/toggleSettingSurat",
      setSettingSuratId: "surat/setSettingSuratId",
      toggleShowSurat: "surat/toggleShowSurat",
      setShowSuratId: "surat/setShowSuratId"
    }),
    uploadFile(type) {
      type == 'surat' ? this.$refs.uploadSurat.click() : this.$refs.uploadLampiran.click();
    },
    onChangeFileUpload(event, type) {
      this.postDocument(event, type);
    },
    handleSettingSurat(uuid) {
      this.setSettingSuratId(uuid);
      this.toggleSettingSurat(true);
    },
    handleShowSurat(uuid) {
      this.setShowSuratId(uuid);
      this.toggleShowSurat(true);
    },
    showFile(uuid) {
      this.$router.openNewTab({ name: "show-document", params: { id: uuid } });
    },
    downloadFile(url) {
      window.open(url);
    },
    submitCallback() {
      this.$emit("submitCallback");
    },
    async postDocument(event, type){
      var self = this;
      const formData = self.getFormDataPayload(event, type);
      self.$refs.loadingDialog.toggleActive(true);
      self.fileLoading = true;
      
      await axios({
        url: "upload/dokumen",
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData,
        onUploadProgress(progressEvent){
          self.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      })
      .then((response) => {
        self.fileLoading = false;
        self.responseValue = response.data.data.data;
      })
      .catch((error) => {
        self.fileLoading = false;
        console.error(error);
        self.$vs.notify({
          title: 'Pemberitahuan',
          text: `Gagal dalam upload dokumen`,
          color: "danger",
          position: "top-right"
        });
      });
    },
    getFormDataPayload(event, type){
      let formData = new FormData();
      let file = event.target.files[0];
      let path = '';
      let tipe = '';

      if(type == 'surat'){
        tipe = this.surat.tipe;
        path = this.surat.tipe == 'surat_keluar' ? 'surat-keluar' : 'surat-masuk';
      }
      else if(type == 'lampiran'){
        tipe = 'lampiran';
        path = 'lampiran';
      }

      formData.append("dokumen_type", "App\\Models\\Surat");
      formData.append("dokumen_id", this.surat.id);
      formData.append("tipe", tipe);
      formData.append("path", path);
      formData.append("file", file);

      return formData;
    },
    handleOnRemoveDocument(documentUuid, type){
      this.$root.confirmDialog({
        title: "Anda yakin akan menghapus dokumen ini ?",
        message: "Dokumen akan dihapus",
        acceptTitle: "Hapus",
        cancelTitle: "Batal",
        onAccept: this.removeDocument(documentUuid, type)
      });
    },
    async removeDocument(documentUuid, type){
      this.fileLoading = true;

      await axios.delete(`/upload/hapus-dokumen/${documentUuid}`)
      .then((response) => {
        this.$emit("submitCallback");
        this.$vs.notify({
          title: 'Pemberitahuan',
          text: `Berhasil menghapus dokumen ${type}`,
          color: "warning",
          position: "top-right"
        });
        this.fileLoading = false;
        return response.data;
      })
      .catch((error) => {
        this.fileLoading = false;
        console.error(error);
        this.$vs.notify({
          title: 'Pemberitahuan',
          text: `Gagal dalam menghapus dokumen ${type}`,
          color: "danger",
          position: "top-right"
        });
      });
    },
  }
};
</script>
